import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { ClientLicenseEntity } from './client-license.entity';

@Index('idx_lda_license', ['fkLicenseId'], {})
@Index('idx_lda_status', ['status'], {})
@Entity('license_disciplinary_action')
export class LicenseDisciplinaryActionEntity extends BaseEntity {
	@Column('int', { name: '_fk_license__id', unsigned: true })
	public fkLicenseId!: number;

	@Column('date', { name: 'action_date' })
	public actionDate!: string;

	@Column('varchar', { name: 'action_type', length: 100 })
	public actionType!: string;

	@Column('varchar', { name: 'severity', length: 50, default: 'Medium' })
	public severity!: string;

	@Column('text', { name: 'description' })
	public description!: string;

	@Column('varchar', { name: 'issuing_authority', length: 255, nullable: true })
	public issuingAuthority!: string | null;

	@Column('varchar', { name: 'case_number', length: 100, nullable: true })
	public caseNumber!: string | null;

	@Column('varchar', { name: 'status', length: 50, default: 'Open' })
	public status!: string;

	@Column('date', { name: 'resolution_date', nullable: true })
	public resolutionDate!: string | null;

	@Column('text', { name: 'resolution', nullable: true })
	public resolution!: string | null;

	@Column('decimal', {
		name: 'fine_amount',
		precision: 12,
		scale: 2,
		nullable: true,
	})
	public fineAmount!: string | null;

	@Column('tinyint', { name: 'fine_paid', width: 1, default: 0 })
	public finePaid!: boolean;

	@ManyToOne(
		() => ClientLicenseEntity,
		(license) => license.disciplinaryActions,
		{
			onDelete: 'CASCADE',
			onUpdate: 'RESTRICT',
		},
	)
	@JoinColumn([{ name: '_fk_license__id', referencedColumnName: 'id' }])
	public fkLicense!: ClientLicenseEntity;
}
